import React from 'react';
import cx from 'classnames';

import { ReactComponent as CheckboxCheckedIcon } from '../../assets/svg/checked-green.svg';
import { ReactComponent as CheckboxUncheckedIcon } from '../../assets/svg/unchecked-icon.svg';

import { Body2, Heading6 } from '../Typography';

import styles from './index.module.scss';

export interface BannerStyleCheckboxProps {
  title: string;
  subtitle?: string;
  className?: string;
  onClick?: () => void;
  checked: boolean;
  iconRightUrl?: string;
  iconRightAlt?: string;
  checkboxContentClassName?: string;
}

const BannerStyleCheckbox: React.FC<BannerStyleCheckboxProps> = ({
  title,
  subtitle,
  className,
  onClick,
  checked = false,
  iconRightUrl,
  iconRightAlt,
  checkboxContentClassName,
}) => {
  return (
    <button
      type='button'
      onClick={onClick}
      className={cx(styles.wrapper, className)}
    >
      <span className={cx(styles.content, checkboxContentClassName)}>
        {checked ? (
          <span
            className={cx(styles.iconLeft, { [styles.noSubtitle]: !subtitle })}
          >
            <CheckboxCheckedIcon />
          </span>
        ) : (
          <span
            className={cx(styles.iconLeft, { [styles.noSubtitle]: !subtitle })}
          >
            <CheckboxUncheckedIcon />
          </span>
        )}
        <span className={styles.textWrapper}>
          <span className={styles.titleAndIconWrapper}>
            <Heading6 className={styles.title}>{title}</Heading6>
            {iconRightUrl && <img src={iconRightUrl} alt={iconRightAlt} />}
          </span>
          {subtitle && <Body2 className={styles.subtitle}>{subtitle}</Body2>}
        </span>
      </span>
    </button>
  );
};

export default BannerStyleCheckbox;
